<template>
  <div class="goods-info" v-if="detailList">
    <!-- 商品名，价格 -->
    <div class="detail-price-wrap" ref="Aa">
      <p class="detail-title">{{ detailList.comName || "未知" }}</p>
      <div class="detail-valuation">
        <!-- 拼团购价格 -->
        <div
          class="valuation-wrap group-wrap-price"
          v-if="detailList.groupBuy && detailList.groupBuy.groupBuyComm"
        >
          <p class="spell-group">
            拼团价：
            <span class="unit">JPY</span>
            {{ detailList.groupBuy.groupBuyPrice || "未知" | setNumber }}
          </p>
          <p class="original-price">
            原&nbsp;&nbsp;&nbsp;&nbsp;价：
            <span class="unit">JPY</span>
            <del>{{ detailList.price || "未知" | setNumber }}</del>
          </p>
        </div>
        <!-- 日元展示 -->
        <div class="valuation-wrap" v-else>
          <span class="unit">JPY</span>
          <span class="unit-price">{{
            detailList.price || "未知" | setNumber
          }}</span>
        </div>
        <!-- 参考价美元，美元展示 -->
        <div class="price-eference" v-if="rmb">
          <p class="price-eference-p">参考价格</p>
          <van-swipe
            :autoplay="3000"
            vertical
            :show-indicators="false"
            :style="{ width: pWidth + 'px' }"
          >
            <van-swipe-item v-if="rmb" :style="{ width: pWidth + 'px' }">
              <span ref="PriceWidth">
                <i>CNY</i>
                <span class="p-number">{{ rmb || "未知" | setNumber }}</span>
              </span>
            </van-swipe-item>
            <van-swipe-item v-if="usd">
              <span :style="{ width: pWidth + 'px' }" class="price">
                <i>USD</i>
                <span class="p-number">{{ usd || "未知" | setNumber }}</span>
              </span>
            </van-swipe-item>
            <van-swipe-item v-if="gbp">
              <span :style="{ width: pWidth + 'px' }" class="price">
                <i>GBP</i>
                <span class="p-number">{{ gbp || "未知" | setNumber }}</span>
              </span>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      current: 0,
      pWidth: "",
      show: false,
      rmb: "",
      usd: "",
      gbp: "",
    };
  },
  props: ["detailList", "price"],
  watch: {
    price: {
      handler(val) {
        this.rmb = val.rmb;
        this.usd = val.usd;
        this.gbp = val.gbp;
        // setTimeout(()=> {
        //   console.log('执行了')

        this.$nextTick(() => {
          this.pWidth = this.$refs.PriceWidth.offsetWidth;
        });

        // },2000)
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.goods-info {
  width: 100%;
  height: auto;
  background: $fc02;
  padding: 30px;
  box-sizing: border-box;
  border-radius: $br20;
  margin-bottom: 8px;
  box-shadow: $box-shadow3;
  /*商品名，价格*/
  .detail-price-wrap {
    .detail-title {
      font-size: 28px;
      color: $fc03;
    }
    .detail-valuation {
      width: 100%;
      // height: 40px;
      line-height: 1;
      margin-top: 20px;
      display: flex;
      overflow: hidden;
      .valuation-wrap {
        font-size: 38px;
        color: $fc04;
        .unit {
          font-size: 30px;
        }
      }
      .group-wrap-price {
        .spell-group {
          font-size: 26px;
          span {
            font-size: 22px;
          }
        }
        .original-price {
          font-size: 24px;
          color: $fc09;
          margin-top: 8px;
          span {
            font-size: 22px;
          }
        }
      }
    }
    .price-eference {
      flex: 1;
      height: 40px;
      line-height: 40px;
      display: flex;
      opacity: 0;
      animation: opacityPrice 2.1s ease-in-out 0s 1 alternate forwards;
      @keyframes opacityPrice {
        40% {
          opacity: 0;
        }
        60% {
          opacity: 0.2;
        }
        80% {
          opacity: 0.8;
        }
        100% {
          opacity: 1;
        }
      }
      .price-eference-p {
        flex: 1;
        font-size: 24px;
        color: $fc09;
        text-align: right;
        margin-right: 16px;
      }
      .van-swipe {
        width: 220px;
        height: 100%;
        line-height: 40px;
        /*font-size: 28px;*/
        .price {
          display: block;
          text-align: right;
          height: 100%;
        }
        .p-number {
          font-size: 30px;
        }
        i {
          font-style: normal;
          font-size: 24px;
          margin-right: 6px;
        }
      }
    }
  }
}
</style>

